import { camelizeKeys } from '@skytech/utils'

import type {
  DeviceApplication,
  DeviceApplicationExtended,
} from '@/modules/applications/device/types'
import { get, post } from '@/util/auth'

const deviceApplicationResources = {
  get: async (deviceApplicationId: number) => {
    const deviceApplications = await get<unknown>(`manager/device-orders/${deviceApplicationId}`)
    const parsedData = camelizeKeys(deviceApplications)

    return parsedData as DeviceApplicationExtended
  },
  getList: async () => {
    const deviceApplications = await get<unknown>('manager/device-orders')
    const parsedApplications = camelizeKeys(deviceApplications)

    return parsedApplications as DeviceApplication[]
  },

  // Mutations
  setStatus: ({
    deviceApplicationId,
    statusId,
  }: {
    deviceApplicationId: number
    statusId: number
  }) =>
    post(`manager/device-orders/${deviceApplicationId}/status`, {
      status: statusId,
    }),
}

export default deviceApplicationResources
